<template>
  <div :class="wrapperClass">
    <span
      class="
        badge
        tw-text-[11px]
        tw-italic
        tw-font-normal
        tw-text-sf-neutral
        tw-mt-2.5
        tw-mr-0.5
        tw-bg-white
        tw-border
        tw-border-solid
        tw-border-sf-neutral-subtle-2
        tw-[text-shadow:none]
      "
    >
      <i
        v-if="loading"
        data-testid="file-badge-loading"
        class="fa fa-spin fa-spinner"
      />
      <span>{{ name }}</span>
      <span class="tw-opacity-50">
        <span v-if="percentage">
          {{ percentage }}
          <span>{{ I18n.t('components.document.queued_single.of') }}</span>
        </span>
        <span>
          {{ formattedBytes }}
        </span>
      </span>
      <i
        class="fa fa-times tw-text-sf-neutral-light-1"
        data-testid="file-badge-remove"
        @click="onRemove(id)"
      />
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { formatBytes } from '@app/utils/file-helpers'

defineOptions({
  name: 'FileBadge',
})

interface Props {
  progress: number | string
  id?: string
  name: string
  loading?: boolean
  fileSize?: number
  onRemove: (_id: string) => void
  wrapperClass?: string
}

const I18n = window.I18n

const props = withDefaults(defineProps<Props>(), {
  id: '',
  fileSize: 0,
  wrapperClass: '',
})

const percentage = computed(() => {
  return props.progress ? `${props.progress}%` : null
})

const formattedBytes = computed(() => {
  return formatBytes(props.fileSize)
})
</script>
